/**
 * @param {{ status?: string }} user
 * @returns {boolean}
 */
// eslint-disable-next-line import/prefer-default-export
export const isActiveUser = (user) => user.status !== 'inactive';
